import React from 'react'

import Table from '@base/Table'

export const DataGridDesempenho = ({ data, field }) => {
  let columns = [ { label: 'Colaborador', name: 'nome', func: null, key: false }, ];
  let list = [];

  let datasPossiveis = [];
  let colaboradoresPossiveis = [];

  // COLS
  data.forEach(d => !datasPossiveis.includes(d.data) ? datasPossiveis.push(d.data) : null);
  datasPossiveis.forEach(d => columns.push({ label: d.substring(0, d.lastIndexOf('/')), name: d, func: null, key: false }));
  columns.push({ label: "Total", name: "total", func: null, key: false });

  // LINES
  data.forEach(c => !colaboradoresPossiveis.includes(c.id) ? colaboradoresPossiveis.push(c.id) : null);
  colaboradoresPossiveis.forEach(c => {
    let line = { nome: data.find(d => d.id === c).nome, total: 0 };

    datasPossiveis.forEach(dP => {
      const d = data.find(d => d.id === c && dP === d.data);
      line[dP] = d ? d[field] ? d[field] : "-" : "-";
      line['total'] += d ? d[field] ? d[field] : 0 : 0;
    });

    list.push(line);
  });

  // ORDENAR POR NOME
  list.sort(function(a, b) {
    var nameA = a.nome.toUpperCase();
    var nameB = b.nome.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });

  // REMOVER REGISTROS COM TOTAL 0
  list = list.filter(l => l.total > 0);

  return (
    <Table
      columns={columns}
      tableData={list}
      actions={[]}
      page={null}
      rowsPerPage={null}
      loading={false}
    />
  )
}

export default DataGridDesempenho;
